module.exports = __webpack_public_path__ + "static/img/10.175c6aa.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/2/sp/10.png
// module id = TkpW
// module chunks = 0